import { render } from "./PageContent.vue?vue&type=template&id=fb152320&scoped=true"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"

import "./PageContent.vue?vue&type=style&index=0&id=fb152320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb152320"]])

export default __exports__